import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import EventGameFacade from "./Facade/EventGameFacade";
import EventGameFilters from "./Models/Filters/EventGameFilters";
import EventGamePredictionsFilters from "./Models/Filters/EventGamePredictionsFilters";
import EventGameRankingsFilters from "./Models/Filters/EventGameRankingsFilters";
import EventGamePredictionModel from "./Models/Prediction/EventGamePredictionModel";
import EventGamePredictionRequestBody from "./Models/Prediction/RequestBody/EventGamePredictionRequestBody";

export default class EventGame {
  private facade: EventGameFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new EventGameFacade(config);
  }

  public getGames = async (
    filters?: EventGameFilters | null,
    disableCache?: boolean
  ) => {
    return await this.facade.getGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache?: boolean) => {
    return await this.facade.getGameById(gameId, disableCache);
  };

  public makePrediction = async (
    gameId: string,
    prediction: EventGamePredictionRequestBody
  ): Promise<EventGamePredictionModel> => {
    return await this.facade.makePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: EventGamePredictionRequestBody
  ): Promise<EventGamePredictionModel> => {
    return await this.facade.updatePrediction(gameId, predictionId, prediction);
  };

  public getGamePredictionsForUser = async (
    gameId: string,
    profileId: string,
    filters?: EventGamePredictionsFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getGamePredictionsForUser(
      gameId,
      profileId,
      filters,
      disableCache
    );
  };

  public getRankings = async (
    gameId: string,
    filters?: EventGameRankingsFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getRankings(gameId, filters, disableCache);
  };
}
